import {
    getUserInfoService
} from '@/service/login';

/**
 * 二级联动数据整理
 * @param {object} subEnum 
 */
function getSubDict(subEnum) {
    var subDict = {};
    for(var i = 0; i < subEnum.length; i ++) {
        var a = subEnum[i];
        var k = a[0].split("." , 2);
        var subList = subDict[k[0]];
        if (subList === undefined ) {
            subList = [];
            subDict[k[0]] = subList;
        }
        subList.push (a);
    }
    return subDict;
}

/**
 * [字符串截取]
 * @param  {[type]} str   [要截取的字符串]
 * @param  {[type]} start [开始位置]
 * @param  {[type]} end   [结束位置]
 * @return {[type]}       [返回截取后的字符串]
 */
function substring(str="",start=0,end=0){
    if(end){
        return str.substring(start,end);
    }else{
        return str.substring(start);
    }
}

/**
 * 获取客户端类型
 * @return {[type]} [description]
 */
function getClient(){
    var sUserAgent = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i);
    var bIsIphoneOs = sUserAgent.match(/iphone os/i);
    var bIsMidp = sUserAgent.match(/midp/i);
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i);
    var bIsUc = sUserAgent.match(/ucweb/i);
    var bIsAndroid = sUserAgent.match(/android/i);
    var bIsCE = sUserAgent.match(/windows ce/i);
    var bIsWM = sUserAgent.match(/windows mobile/i);
    var wx = sUserAgent.match(/microMessenger/i);
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM){
        if(wx){
            return "wx";
        }else{
            return "mobile";
        }
    }else{
       return "pc";
    }
}

/**
 * 根据stat的状态获取stat_text的值
 * code=1 您已经申请过了，清耐心等待客服与您联系
 * code=2 您已经申请过了，考虑好了清致电 XXXX
 * code=3 打开表单，可再次申请
 * code=4 您已经申请过了，考虑好了清致电 XXXX
 * code=5 您已经申请过了，如已付款清致电 XXXX
 * code=6 直接跳转，并把全局 vip 标识设为 true，下次不再判断
 */
function getAuthorStatTxt(stat){
    switch(stat){
        case "1":
            return "您已经申请过了，请耐心等待客服与您联系";
        case "2":
            return "您已经申请过了，考虑好了清致电 XXXX";
        case "3":
            return "打开表单，可再次申请";
        case "4":
            return "您已经申请过了，考虑好了清致电 XXXX";
        case "5":
            return "您已经申请过了，如已付款清致电 XXXX";
        default:
            return "";
    }
}

/**
 * 去除空格
 * @param  {String} str [要去除的字符串]
 * @param  {String} loc [去除的位置]
 * @return {[type]}     [返回去除空格后的字符串]
 */
function trim(str="",loc="all"){
    let reg = /\s*/g;
    switch(loc){
        case "both":
            reg = /^\s*|\s*$/g;
            break;
        case "left":
            reg = /^\s*/g;
            break;
        case "right":
            reg = /(\s*$)/g;
            break;
        default:
            break;
    }

    return str.replace(reg,"");
}

/**
 * 检查是否登录
 */
async function checkLogin(){
    let isLogin = false;
    let globalUID = sessionStorage.getItem("globalUID");
    if(globalUID){
        return true;
    }

    let rsp = await getUserInfoService();
    if(rsp.data && rsp.data.ok && !rsp.data.err){
        let info = rsp.data.info || {};
        if(info.id){
            sessionStorage.setItem('globalUID',info.id);
            return true;
        }
    }

    if(!isLogin){
        let pathname = location.pathname;
        let search = location.search;
        let toPage = encodeURIComponent(pathname+search);
        window.location.href = "/public/home/login?r=" + toPage;
    }

    return isLogin;
}

function getTree(arr){
    let result = {};
    arr.forEach(item=>{
        if(item[0]){
            let value = item[0];
            let text = item[1];
            let reg = /-/g;
            let reg2 = /\./g;
            if(reg.test(value)){ //表示的是最后一个
                let key = value.split("-")[0];
                let obj ={value,text};
                if(!result[key]){
                    result[key] = [];
                }
                result[key].push(obj);
            }else if(reg2.test(value)){ //表示的是中间的子集
                let key = value.slice(0,value.lastIndexOf("."));
                let obj ={value,text};
                if(!result[key]){
                    result[key] = [];
                }
                result[key].push(obj);
            }else{
                let obj ={value,text};
                if(!result.father){
                    result.father = [];
                }
                result.father.push(obj);
            }
        }
    });

    return result;
}

export default{
    getSubDict,
    substring,
    getClient,
    getAuthorStatTxt,
    trim,
    checkLogin,
    getTree
}


// WEBPACK FOOTER //
// ./src/config/common.js